module.exports = "/_next/static/images/Bolts-c4f7a35ca7a6f68e4e4325237d360dc7.png";